module.exports = __webpack_public_path__ + "static/media/galerija_2017 (2).e79a06a7.jpg";